import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';
import { useState } from 'react';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';

const whyFeatures = [
  { icon: 'ri-router-line', title: 'Altyapı Karmaşıklığını Azaltır', desc: 'Yönetim düzlemi ağ yönetimi VergeOS\'a entegre edilmiştir; ayrı SDN lisansı veya ekipmanı gerekmez.' },
  { icon: 'ri-shield-check-line', title: 'VM ve VDC Düzeyi Segmentasyonla Güvenliği Artırır', desc: 'Çok kiracılı VDC ortamları tam ağ izolasyonu ve yerleşik güvenlik politikalarıyla çalışır.' },
  { icon: 'ri-wifi-line', title: 'Karmaşık VPN Yapılandırması Olmadan SDN Bağlantısını Etkinleştirir', desc: 'Siteler arası bağlantı, ek VPN donanımı veya karmaşık yapılandırma gerektirmeksizin dahili olarak kurulur.' },
  { icon: 'ri-speed-line', title: 'Yerleşik Ağ Otomasyonu ile Olağanüstü Durum Kurtarma Süresini Kısaltır', desc: 'VDC\'lerin yeniden konumlandırılması ve ağ yapılandırmasının kopyalanması saniyeler içinde, ek araç gerektirmeksizin gerçekleşir.' },
];

const advancedCapabilities = [
  { category: 'Dinamik Yönlendirme', feature: 'BGP (Sınır Ağ Geçidi Protokolü)', desc: 'Esnek yönlendirme sağlar ve birden fazla ağ ile veri merkezini destekler.' },
  { category: '', feature: 'OSPF (En Kısa Yol Bulma)', desc: 'Dinamik iç ağ yönlendirmesi, giden trafiği optimize eder.' },
  { category: '', feature: 'EIGRP (Gelişmiş İç Geçit Yönlendirme Protokolü)', desc: 'Dahili yönlendirme için verimli adaptif yönlendirme sağlar.' },
  { category: 'Siteden Siteye VPN', feature: 'IPSec VPN', desc: 'Çoklu site bağlantısı için güvenli, şifrelenmiş tünel oluşturur.' },
  { category: '', feature: 'WireGuard VPN', desc: 'Siteden siteye bağlantı için hafif, yüksek performanslı VPN çözümü.' },
  { category: 'İstemci Tabanlı VPN', feature: 'Durum Bilgili Güvenlik Duvarı', desc: 'Katman 3 ve 4 kural tabanlı güvenlik duvarı, gelen/giden trafiği kontrol eder.' },
  { category: 'Güvenlik', feature: 'Port Yansıtma', desc: 'Güvenlik analizi için SpanFlow ve NetFlow trafiğini izler.' },
  { category: '', feature: 'Güvenlik Duvarı Kural Günlüğü', desc: 'Güvenlik denetimleri için Katman 3 ve 4 trafik modellerini kaydeder.' },
  { category: 'DHCP', feature: 'DHCP Sunucusu', desc: 'Ağ cihazlarına otomatik IP adresi ataması sağlar.' },
  { category: 'Çeşitli', feature: 'Statik Rotalar', desc: 'Ağ rotalarının öngörülebilir yönetimini sağlar.' },
  { category: '', feature: 'NAT (Ağ Adresi Çevirisi)', desc: 'Dahili ve harici ağlar arasında güvenli, esnek trafik yönlendirmesi sağlar.' },
  { category: '', feature: 'DNS Hizmetleri', desc: 'Entegre alan adı çözümleme hizmetleri ve performansı.' },
  { category: 'Ağ Tanılamaları', feature: 'Netcat', desc: 'Esnek ve sürtünmesiz ağ bağlantısı ve performansı.' },
  { category: '', feature: 'Nmap', desc: 'Bağlı olmayan cihazlar ve güvenlik açıklarını tarar.' },
];

const sdnFeatures = [
  'Ayrılmış SDN VPN\'leri yok — CPU ve belleği boşa harcamıyor',
  'Devre dışı bırakılan lisanslama ücretleri — VergeOS ile ek maliyet yok',
  'Basitleştirilmiş üçüncü taraf entegrasyonları — yönetimi kolay',
  'Pahalı özel donanım gerekmiyor — emtia ağ anahtarlarıyla çalışır',
];

const faqList = [
  { q: 'VergeFabric nedir?', a: 'VergeFabric, VergeOS\'a entegre Software-Defined Networking (SDN) çözümüdür. Ayrı SDN donanım veya lisansı olmaksızın, sanallaştırılmış altyapınızda dinamik yönlendirme, güvenlik duvarı, VPN ve ağ segmentasyonu sunar.' },
  { q: 'VergeFabric VMware NSX\'ten nasıl farklıdır?', a: 'Diğer platformlar ayrı bir ürün olarak ek lisans ve kurulum gerektirir. VergeFabric ise VergeOS\'a yerel olarak entegre edilmiştir; bu da kurulum, yönetim ve maliyet açısından önemli avantajlar sağlar.' },
  { q: 'Hangi güvenlik özellikleri VergeFabric ile kullanılabilir?', a: 'Durum bilgili güvenlik duvarı, port yansıtma, güvenlik duvarı kural günlüğü, VM ve VDC düzeyinde ağ segmentasyonu ve IPSec/WireGuard VPN dahil kapsamlı güvenlik yetenekleri bulunmaktadır.' },
  { q: 'VergeFabric yüksek erişilebilirliğe yardımcı olur mu?', a: 'Evet. Dahili ağ otomasyonu ile VDC\'leri yeniden konumlandırabilir ve ağ yapılandırmalarını kopyalayabilirsiniz; bu işlem saniyeler içinde gerçekleşir ve olağanüstü durum kurtarma sürelerini önemli ölçüde kısaltır.' },
  { q: 'VergeFabric çok kiracılı bağlantıyı destekler mi?', a: 'Evet. VergeFabric, VDC\'lerin tam ağ izolasyonuna sahip olmasını sağlayan Sanal Veri Merkezleri (VDC) ile sorunsuz çalışır. Her kiracı kendi güvenlik duvarı, yönlendirme ve bağlantı politikalarına sahip olabilir.' },
  { q: 'VDC\'ler (Sanal Veri Merkezleri) nedir?', a: 'VDC\'ler, VergeOS\'un entegre özelliğidir. Her on-premises veri merkezinde bulunan bu sanal veri merkezleri, güvenli çok kiracı yönetimine olanak tanır. VDC\'ler iş yüklerini izole etmek, güvenli çapraz iletişim kurmak ve kaynakları dinamik olarak tahsis etmek için kullanılabilir.' },
  { q: 'VergeFabric aracılığıyla VDC\'leri yönetebilir miyim?', a: 'Evet. VergeFabric ve VDC\'ler birlikte çalışarak üst düzey yönetim ve izolasyon sağlar. Ek lisanslama veya karmaşık yapılandırma olmaksızın VDC tabanlı trafik yönetimini, güvenlik duvarı kurallarını ve erişim kontrolünü dahil edebilirsiniz.' },
];

const vergefabricFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'VergeFabric nedir?', acceptedAnswer: { '@type': 'Answer', text: "VergeFabric, VergeOS'a entegre Software-Defined Networking (SDN) çözümüdür. Ayrı SDN donanım veya lisansı olmaksızın dinamik yönlendirme, güvenlik duvarı, VPN ve ağ segmentasyonu sunar." } },
    { '@type': 'Question', name: "VergeFabric nasıl farklıdır?", acceptedAnswer: { '@type': 'Answer', text: "Diğer platformlar ayrı bir ürün olarak ek lisans ve kurulum gerektirir. VergeFabric ise VergeOS'a yerel olarak entegre edilmiştir." } },
    { '@type': 'Question', name: 'Hangi güvenlik özellikleri VergeFabric ile kullanılabilir?', acceptedAnswer: { '@type': 'Answer', text: 'Durum bilgili güvenlik duvarı, port yansıtma, güvenlik duvarı kural günlüğü, VM ve VDC düzeyinde ağ segmentasyonu ve IPSec/WireGuard VPN dahil kapsamlı güvenlik yetenekleri bulunmaktadır.' } },
    { '@type': 'Question', name: 'VergeFabric yüksek erişilebilirliğe yardımcı olur mu?', acceptedAnswer: { '@type': 'Answer', text: "Evet. Dahili ağ otomasyonu ile VDC'leri yeniden konumlandırabilir ve ağ yapılandırmalarını kopyalayabilirsiniz; bu işlem saniyeler içinde gerçekleşir." } },
    { '@type': 'Question', name: "VDC'ler (Sanal Veri Merkezleri) nedir?", acceptedAnswer: { '@type': 'Answer', text: "VDC'ler, VergeOS'un entegre özelliğidir. Her on-premises veri merkezinde bulunan bu sanal veri merkezleri, güvenli çok kiracı yönetimine olanak tanır." } },
  ],
};

const vergefabricAppJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeFabric',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'VergeOS entegre SDN çözümü. Ayrı lisans gerektirmeden BGP, OSPF, IPSec VPN, durum bilgili güvenlik duvarı ve çok kiracılı ağ segmentasyonu.',
  url: `${SITE_URL}/vergefabric`,
};

export default function VergeFabricPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="VergeFabric | Yazılım Tanımlı Ağ | VergeOS SDN"
        description="VergeFabric, VergeOS'a entegre SDN çözümüdür. BGP, OSPF, IPSec/WireGuard VPN, durum bilgili güvenlik duvarı ve çok kiracılı ağ segmentasyonu ek lisans olmadan."
        keywords="VergeFabric, SDN, yazılım tanımlı ağ, ağ sanallaştırma, BGP, OSPF, VPN, VMware NSX alternatifi"
        canonicalPath="/vergefabric"
        jsonLd={[vergefabricAppJsonLd, vergefabricFaqJsonLd]}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20"
            style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
              Mimari
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              <span className="text-[#e8600a]">VergeFabric</span>
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">Gelişmiş L2 ve L3 Ağ Yönetimi</p>
            <p className="text-gray-400 text-sm mb-8">VergeOS'a Entegre</p>
          </div>
        </section>

        {/* Rethink Networking */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Ağa Yaklaşımınızı Yeniden Düşünün</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Altyapı depolama maliyetlerini azaltmaya odaklanırken, ağ maliyetleri artıyor. Karmaşık SDN yönetimi, gereksiz lisanslama maliyetleri ve operasyonel yük birikiyor.
                </p>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  <strong className="text-[#1e293b]">VergeFabric</strong> bu engelleri VergeOS'a doğrudan entegre gelişmiş ağ yetenekleri sunarak ortadan kaldırır. Ayrı lisanslama, ayrı ekipman, karmaşık yönetim — hepsi ortadan kalkar.
                </p>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/bbdb4b9a70188bd207664cb7705db67a.jpg"
                  alt="VergeFabric Ağ Mimarisi"
                  className="w-full h-full object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Why VergeFabric */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl font-bold text-[#1e293b] mb-4">Neden VergeFabric?</h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-sm">
                Geleneksel SDN çözümleri bağımsız lisanslama, özel donanım ve karmaşık yapılandırma gerektirir. VergeFabric bunları ortadan kaldırır.
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {whyFeatures.map((f) => (
                <div key={f.title} className="bg-white rounded-lg border border-gray-100 p-6 flex gap-4">
                  <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] shrink-0">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{f.title}</h3>
                    <p className="text-xs text-gray-600 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* VDC Section */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Sanal Veri Merkezleri (VDC) Ağ Segmentasyonu ve Çok Kiracılılık</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  VergeFabric, Sanal Veri Merkezleri (VDC) ile sorunsuz çalışır; bu da on-premises veri merkezinizde bulunan integral bir VergeOS özelliğidir.
                </p>
                <ul className="space-y-3 mb-6">
                  {[
                    'Güvenli çok kiracılı yönetim için iş yüklerini segment iş akışlarına ayırın.',
                    'Çapraz VDC iletişimi için tek bir fiziksel altyapı içinde izole edilmiş ağ ortamları oluşturun.',
                    'Öngörülebilir ve kolayca izlenebilir yönlendirme sağlayarak VDC başına ayrılmış ağ kaynakları tahsis edin.',
                    'VDC ortamlarını çoğaltarak ağ yapılandırmaları dahil hızlı yük devri ve kurtarma sağlayarak kurtarma süresini basitleştirin.',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm text-gray-700">
                      <i className="ri-check-double-line text-[#e8600a] text-lg shrink-0 mt-0.5"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=virtual%20data%20center%20network%20segmentation%20multi-tenancy%20diagram%20showing%20isolated%20VDC%20containers%20with%20separate%20network%20policies%20firewall%20rules%20and%20routing%20in%20dark%20background%20orange%20highlights%20technical%20enterprise%20architecture%20visualization&width=580&height=420&seq=vergefabric_vdc1&orientation=landscape"
                  alt="VDC Ağ Segmentasyonu"
                  className="w-full h-full object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* SDN Without Cost */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=cost%20effective%20software%20defined%20networking%20visualization%20showing%20commodity%20network%20switches%20with%20automated%20management%20overlay%2C%20simplified%20network%20management%20dashboard%20with%20orange%20accent%20colors%2C%20enterprise%20network%20without%20expensive%20proprietary%20hardware%20dark%20minimal%20design&width=580&height=380&seq=vergefabric_sdn1&orientation=landscape"
                  alt="Maliyet Olmadan SDN"
                  className="w-full h-full object-top"
                />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Maliyet veya Karmaşıklık Olmadan Entegre SDN</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Bağımsız SDN çözümlerinin aksine VergeFabric, VergeOS'a tam olarak entegre edilmiştir; bu da şunları ortadan kaldırır:
                </p>
                <ul className="space-y-3">
                  {sdnFeatures.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm text-gray-700">
                      <i className="ri-close-circle-line text-gray-400 text-lg shrink-0 mt-0.5"></i>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-gray-50 border-t border-gray-200">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">VergeFabric SSS</h2>
            <div className="space-y-4">
              {faqList.map((faq, i) => (
                <div key={i} className="bg-white rounded-lg border border-gray-100 overflow-hidden">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer">
                    <span className="font-medium text-[#1e293b] text-sm">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0">
                      <i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                    </span>
                  </button>
                  {openFaq === i && (
                    <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Advanced Capabilities Table */}
        <section className="py-20 bg-white border-t border-gray-200">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Gelişmiş Ağ Yetenekleri</h2>
            <div className="overflow-x-auto rounded-lg border border-gray-200">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[#0f1117] text-white">
                    <th className="px-4 py-3 text-left font-semibold">Kategori</th>
                    <th className="px-4 py-3 text-left font-semibold">Özellik</th>
                    <th className="px-4 py-3 text-left font-semibold">Açıklama</th>
                  </tr>
                </thead>
                <tbody>
                  {advancedCapabilities.map((row, i) => (
                    <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="px-4 py-3 text-gray-500 font-medium whitespace-nowrap">{row.category}</td>
                      <td className="px-4 py-3 text-[#1e293b] font-medium whitespace-nowrap">{row.feature}</td>
                      <td className="px-4 py-3 text-gray-600">{row.desc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
